import React, { useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {
  FaGraduationCap,
  FaChartLine,
  FaBook,
  FaBuilding,
  FaEnvelope,
  FaPhone,
  FaOrcid,
  FaChartBar,
  FaFileAlt,
} from 'react-icons/fa';
import {
  SiResearchgate,
  SiScopus,
  SiGooglescholar
} from 'react-icons/si';
import styles from './Profil.module.css';

const Profil = () => {
  const [activeTab, setActiveTab] = useState('akademik');

  const tabs = [
    { id: 'akademik', title: 'Akademik Bilgiler', icon: <FaGraduationCap /> },
    { id: 'istatistik', title: 'İstatistikler', icon: <FaChartLine /> },
    { id: 'yayinlar', title: 'Yayınlar', icon: <FaBook /> }
  ];

  const chartOptions = {
    chart: {
      type: 'line',
      style: {
        fontFamily: 'inherit'
      }
    },
    title: {
      text: null
    },
    xAxis: {
      categories: ['2019', '2020', '2021', '2022', '2023', '2024']
    },
    yAxis: {
      title: {
        text: null
      }
    },
    plotOptions: {
      line: {
        marker: {
          enabled: true,
          radius: 4
        }
      }
    },
    legend: {
      align: 'center',
      verticalAlign: 'bottom'
    },
    credits: {
      enabled: false
    },
    accessibility: {
      enabled: false
    },
    series: [
      {
        name: 'Yayınlar',
        color: '#4285f4',
        data: [10, 15, 18, 22, 28, 32]
      },
      {
        name: 'Projeler',
        color: '#34a853',
        data: [2, 4, 5, 7, 8, 10]
      },
      {
        name: 'Atıflar',
        color: '#fbbc05',
        data: [50, 120, 200, 350, 500, 850]
      }
    ]
  };

  const timelineItems = [
    {
      id: 1,
      date: 'Mart 2024',
      title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
    },
    {
      id: 2,
      date: 'Şubat 2024',
      title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
    },
    {
      id: 3,
      date: 'Ocak 2024',
      title: 'Uluslararası Konferans',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
    }
  ];

  const publicationsData = [
    {
      yil: '2023',
      q1: 3,
      q2: 2,
      q3: 1,
      q4: 0,
      toplam: 6
    },
    {
      yil: '2022',
      q1: 4,
      q2: 3,
      q3: 2,
      q4: 1,
      toplam: 10
    },
    {
      yil: '2021',
      q1: 2,
      q2: 2,
      q3: 1,
      q4: 1,
      toplam: 6
    }
  ];

  const yayinHedefler = [
    { yil: '2024', hedef: 5, gerceklesen: 1, not: 'Q1 kategorisinde 2 yayın hedefi var' },
    { yil: '2023', hedef: 4, gerceklesen: 4, not: 'Hedef tamamlandı' },
    { yil: '2022', hedef: 3, gerceklesen: 4, not: 'Hedef aşıldı' },
    { yil: '2021', hedef: 3, gerceklesen: 3, not: 'Hedef tamamlandı' }
  ];

  const notlar = [
    {
      tarih: '2024-01-05',
      icerik: 'Q1 kategorisinde 2 yeni yayın hedefi belirlendi.'
    },
    {
      tarih: '2023-12-15',
      icerik: 'TÜBİTAK 1001 projesi başvurusu yapıldı.'
    },
    {
      tarih: '2023-12-01',
      icerik: 'Yeni doktora öğrencisi danışmanlığı başladı.'
    }
  ];

  const performanceChartOptions = {
    chart: {
      type: 'column',
      height: 350,
      style: {
        fontFamily: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }
    },
    title: {
      text: null
    },
    xAxis: {
      categories: ['2019', '2020', '2021', '2022', '2023', '2024'],
      crosshair: true,
      labels: {
        style: {
          color: '#6b7280'
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Yayın Sayısı',
        style: {
          color: '#6b7280'
        }
      },
      labels: {
        style: {
          color: '#6b7280'
        }
      },
      gridLineColor: '#e5e7eb'
    },
    legend: {
      align: 'right',
      verticalAlign: 'top',
      symbolRadius: 2,
      itemStyle: {
        color: '#6b7280',
        fontWeight: 'normal',
        fontSize: '12px'
      }
    },
    tooltip: {
      shared: true,
      backgroundColor: '#ffffff',
      borderColor: '#e5e7eb',
      borderRadius: 6,
      shadow: true,
      useHTML: true,
      headerFormat: '<table><tr><td colspan="2"><b>{point.key}</b></td></tr>',
      pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td><td style="text-align: right"><b>{point.y}</b></td></tr>',
      footerFormat: '</table>'
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        borderRadius: 4,
        groupPadding: 0.1
      },
      series: {
        animation: {
          duration: 1000
        }
      }
    },
    series: [
      {
        name: 'Hedef',
        color: '#e5e7eb',
        data: [3, 3, 3, 3, 4, 5]
      },
      {
        name: 'Gerçekleşen',
        color: '#3b82f6',
        data: [2, 3, 3, 4, 4, 1]
      }
    ],
    credits: {
      enabled: false
    },
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          legend: {
            align: 'center',
            verticalAlign: 'bottom'
          }
        }
      }]
    }
  };

  return (
    <div className={styles.wrapper}>
      <PageHeader 
        title="Profil"
        description="Akademik yayın performansı ve istatistikler"
        breadcrumbs={[
          { text: 'Ana Sayfa', href: '/' },
          { text: 'Profil' },
        ]}
      />

      <div className="row g-4">
        <div className="col-md-4">
          <div className={styles['profile-card']}>
            <div className={styles['profile-avatar']}>
              <img
                src="https://randomuser.me/api/portraits/men/1.jpg"
                alt="Profil Fotoğrafı"
              />
              <button className={styles['camera-btn']}>
                <i className="fas fa-camera"></i>
              </button>
            </div>
            <h5 className="mb-1">Prof. Dr. Lorem Ipsum</h5>
            <p className="text-muted mb-3">Akademisyen</p>
            <div className={styles['social-buttons']}>
              <a href="#" className={`${styles['social-btn']} ${styles.scholar}`} title="Google Scholar">
                <SiGooglescholar />
              </a>
              <a href="#" className={`${styles['social-btn']} ${styles.researchgate}`} title="ResearchGate">
                <SiResearchgate />
              </a>
              <a href="#" className={`${styles['social-btn']} ${styles.orcid}`} title="ORCID">
                <FaOrcid />
              </a>
              <a href="#" className={`${styles['social-btn']} ${styles.scopus}`} title="Scopus">
                <SiScopus />
              </a>
            </div>
            <div className={styles['stats-row']}>
              <div className={styles['stat-item']}>
                <div className={styles['stat-value']}>45</div>
                <div className={styles['stat-label']}>Yayın</div>
              </div>
              <div className={styles['stat-item']}>
                <div className={styles['stat-value']}>12</div>
                <div className={styles['stat-label']}>Proje</div>
              </div>
              <div className={styles['stat-item']}>
                <div className={styles['stat-value']}>850</div>
                <div className={styles['stat-label']}>Atıf</div>
              </div>
            </div>
          </div>

          <div className={`${styles['info-card']} mt-4`}>
            <div className={styles['info-header']}>
              <div className={`${styles['info-icon']} bg-primary bg-opacity-10 text-primary`}>
                <i className="fas fa-info-circle"></i>
              </div>
              <h6 className={styles['info-title']}>İletişim Bilgileri</h6>
            </div>
            <div className="p-3">
              <div className={styles['contact-item']}>
                <i className={`fas fa-envelope ${styles['contact-icon']}`}></i>
                <div className={styles['contact-content']}>
                  <small className={styles['contact-label']}>E-posta</small>
                  <span className={styles['contact-value']}>lorem.ipsum@ornek.edu.tr</span>
                </div>
              </div>
              <div className={styles['contact-item']}>
                <i className={`fas fa-phone ${styles['contact-icon']}`}></i>
                <div className={styles['contact-content']}>
                  <small className={styles['contact-label']}>Telefon</small>
                  <span className={styles['contact-value']}>+90 212 285 XX XX</span>
                </div>
              </div>
              <div className={styles['contact-item']}>
                <i className={`fas fa-building ${styles['contact-icon']}`}></i>
                <div className={styles['contact-content']}>
                  <small className={styles['contact-label']}>Ofis</small>
                  <span className={styles['contact-value']}>Ayazağa Kampüsü, A Blok, No: 101</span>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles['info-card']} mt-4`}>
            <div className={styles['info-header']}>
              <div className={`${styles['info-icon']} bg-primary bg-opacity-10 text-primary`}>
                <FaGraduationCap />
              </div>
              <h6 className={styles['info-title']}>Akademik Kimlikler</h6>
            </div>
            <div className={styles['academic-ids']}>
              <p>
                <FaOrcid style={{ color: '#A6CE39' }} />
                <a href="https://orcid.org/0000-0002-1234-5678" target="_blank" rel="noopener noreferrer">
                  0000-0002-1234-5678
                </a>
              </p>
              <p>
                <SiResearchgate style={{ color: '#00CCBB' }} />
                <a href="https://www.researcherid.com/A-1234-5678" target="_blank" rel="noopener noreferrer">
                  Research ID: A-1234-5678
                </a>
              </p>
              <p>
                <SiScopus style={{ color: '#E9711C' }} />
                <a href="https://www.scopus.com/authid/detail.uri?authorId=57123456789" target="_blank" rel="noopener noreferrer">
                  Scopus ID: 57123456789
                </a>
              </p>
              <p>
                <SiGooglescholar style={{ color: '#4285F4' }} />
                <a href="https://scholar.google.com/citations?user=ABC123" target="_blank" rel="noopener noreferrer">
                  Google Scholar
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="col-md-8">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-white p-3">
              <ul className="nav nav-tabs border-0">
                {tabs.map(tab => (
                  <li className="nav-item" key={tab.id}>
                    <button
                      className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      <span className="me-2">{tab.icon}</span>
                      {tab.title}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div className="card-body">
              {activeTab === 'akademik' && (
                <>
                  <form className="mb-4">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label small text-muted">Ünvan</label>
                        <input type="text" className="form-control bg-light" value="Prof. Dr." readOnly />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label small text-muted">Fakülte</label>
                        <input type="text" className="form-control bg-light" value="Mühendislik Fakültesi" readOnly />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label small text-muted">Bölüm</label>
                        <input type="text" className="form-control bg-light" value="Bilgisayar Mühendisliği" readOnly />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label small text-muted">Başlangıç Tarihi</label>
                        <input type="text" className="form-control bg-light" value="01.09.2005" readOnly />
                      </div>
                      <div className="col-12">
                        <label className="form-label small text-muted">Uzmanlık Alanları</label>
                        <div className={styles['expertise-tags']}>
                          <span className={styles['expertise-tag']}>Yapay Zeka</span>
                          <span className={styles['expertise-tag']}>Makine Öğrenmesi</span>
                          <span className={styles['expertise-tag']}>Veri Madenciliği</span>
                          <span className={styles['expertise-tag']}>Derin Öğrenme</span>
                          <span className={styles['expertise-tag']}>Bilgisayarlı Görü</span>
                        </div>
                      </div>
                    </div>
                  </form>

                  <div className={styles.timeline}>
                    <h6 className="mb-4">Son Aktiviteler</h6>
                    {timelineItems.map(item => (
                      <div key={item.id} className={styles['timeline-item']}>
                        <div className={styles['timeline-date']}>{item.date}</div>
                        <div className={styles['timeline-title']}>{item.title}</div>
                        <div className={styles['timeline-description']}>{item.description}</div>
                      </div>
                    ))}
                  </div>
                </>
              )}

              {activeTab === 'istatistik' && (
                <>
                  <div className={styles['chart-container']}>
                    <div className={styles['chart-header']}>
                      <h6 className={styles['chart-title']}>Performans Grafiği</h6>
                    </div>
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={chartOptions}
                    />
                  </div>

                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className={styles['info-card']}>
                        <div className={styles['info-header']}>
                          <div className={`${styles['info-icon']} bg-primary bg-opacity-10 text-primary`}>
                            <i className="fas fa-book"></i>
                          </div>
                          <div>
                            <h3 className="mb-0">45</h3>
                            <small className="text-muted">Toplam Yayın</small>
                          </div>
                        </div>
                        <div className="p-3">
                          <div className="progress" style={{height: '4px'}}>
                            <div className="progress-bar bg-primary" style={{width: '75%'}}></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className={styles['info-card']}>
                        <div className={styles['info-header']}>
                          <div className={`${styles['info-icon']} bg-success bg-opacity-10 text-success`}>
                            <i className="fas fa-project-diagram"></i>
                          </div>
                          <div>
                            <h3 className="mb-0">12</h3>
                            <small className="text-muted">Aktif Proje</small>
                          </div>
                        </div>
                        <div className="p-3">
                          <div className="progress" style={{height: '4px'}}>
                            <div className="progress-bar bg-success" style={{width: '60%'}}></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {activeTab === 'yayinlar' && (
                <>
                  <div className={styles['publications-card']}>
                    <div className={styles['publication-stats']}>
                      <div className={styles['stat-item']}>
                        <span className={styles['stat-label']}>Q1:</span>
                        <span className={styles['stat-value']}>15</span>
                      </div>
                      <div className={styles['stat-item']}>
                        <span className={styles['stat-label']}>Q2:</span>
                        <span className={styles['stat-value']}>12</span>
                      </div>
                      <div className={styles['stat-item']}>
                        <span className={styles['stat-label']}>Q3:</span>
                        <span className={styles['stat-value']}>8</span>
                      </div>
                      <div className={styles['stat-item']}>
                        <span className={styles['stat-label']}>Q4:</span>
                        <span className={styles['stat-value']}>5</span>
                      </div>
                      <div className={styles['stat-item']}>
                        <span className={styles['stat-label']}>D. M/R:</span>
                        <span className={styles['stat-value']}>3</span>
                      </div>
                      <div className={styles['stat-item']}>
                        <span className={styles['stat-label']}>Diğer:</span>
                        <span className={styles['stat-value']}>2</span>
                      </div>
                    </div>
                    <div className={styles['target-table']}>
                      <table>
                        <thead>
                          <tr>
                            <th>Yıl</th>
                            <th>Q1</th>
                            <th>Q2</th>
                            <th>Q3</th>
                            <th>Q4</th>
                            <th>Toplam</th>
                          </tr>
                        </thead>
                        <tbody>
                          {publicationsData.map((row, index) => (
                            <tr key={index}>
                              <td>{row.yil}</td>
                              <td>{row.q1}</td>
                              <td>{row.q2}</td>
                              <td>{row.q3}</td>
                              <td>{row.q4}</td>
                              <td>{row.toplam}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid px-0 mb-4">
        <div className="row">
          <div className="col-md-8">
            <div className={styles['chart-card']}>
              <div className={styles['card-header']}>
                <h3 className={styles['card-title']}>
                  <FaChartBar />
                  Yayın Performansı
                </h3>
              </div>
              <div className={styles['publication-targets']}>
                <div className={styles['target-table']}>
                  <table>
                    <thead>
                      <tr>
                        <th>Yıl</th>
                        <th>Hedef</th>
                        <th>Gerçekleşen</th>
                        <th>Durum</th>
                        <th>Not</th>
                      </tr>
                    </thead>
                    <tbody>
                      {yayinHedefler.map((hedef, index) => (
                        <tr key={index}>
                          <td>{hedef.yil}</td>
                          <td>{hedef.hedef}</td>
                          <td>{hedef.gerceklesen}</td>
                          <td>
                            <span className={`badge ${hedef.gerceklesen >= hedef.hedef ? 'bg-success' : 'bg-warning'}`}>
                              {hedef.gerceklesen >= hedef.hedef ? 'Tamamlandı' : 'Devam Ediyor'}
                            </span>
                          </td>
                          <td>{hedef.not}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <HighchartsReact highcharts={Highcharts} options={performanceChartOptions} />
            </div>
          </div>
          <div className="col-md-4">
            <div className={styles['notes-card']}>
              <div className={styles['card-header']}>
                <h3 className={styles['card-title']}>
                  <FaFileAlt />
                  Notlar ve Değerlendirmeler
                </h3>
              </div>
              <div className={styles['notes-list']}>
                {notlar.map((not, index) => (
                  <div key={index} className={styles['note-item']}>
                    <div className={styles['note-header']}>
                      <span className={styles['note-date']}>
                        {new Date(not.tarih).toLocaleDateString('tr-TR', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                      </span>
                    </div>
                    <p className={styles['note-content']}>{not.icerik}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profil; 